module.exports = __webpack_public_path__ + "static/media/qqbxc.18f7079.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/qqbxc.mp4
// module id = 5oUt
// module chunks = 0